import React, { useEffect, useState } from 'react';
import { estimateOrder, etaLabel, type EtaInput } from '../../service/OrderEta';

// One line: "Ready at about 19:35" / "Arriving about 19:50–20:00". Re-renders
// each minute so a stale promise disappears on its own.
const OrderEtaLine: React.FC<{ input: EtaInput; color?: string; compact?: boolean }> = ({ input, color, compact }) => {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 60_000); return () => clearInterval(t); }, []);
  const label = etaLabel(estimateOrder(input));
  if (!label) return null;
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: compact ? 12 : 14, fontWeight: 600, color: color || 'inherit', marginTop: compact ? 2 : 6 }}
      title="An estimate based on the kitchen's usual preparation time and, for delivery, the driving time.">
      <span aria-hidden>⏱</span>
      <span>{label}</span>
      {!compact && <span style={{ fontWeight: 400, opacity: 0.7, fontSize: 12 }}>(estimate)</span>}
    </div>
  );
};

export default OrderEtaLine;
